/**
 * Thin vanity wrapper around all access to environment variables to provide a cleaner
 * interface to these low-level and global variable references.
 */

declare var __FE_ENV__: string;
declare var __FE_RELEASE_ID__: string;
declare var __OPTIMIZELY_SDK_KEY__: string;

export const optimizelyEnvironment = __FE_ENV__;
export const releaseId = __FE_RELEASE_ID__;
export const optimizelySDKKey = __OPTIMIZELY_SDK_KEY__;

export function isDeployed() {
  return process.env.NODE_ENV === 'production';
}

export const scsName = 'FLAGS';

const environment = {
  isDeployed,
  optimizelyEnvironment,
  optimizelySDKKey,
  releaseId,
  scsName,
};

export default environment;
